import React from 'react'

import revixLogo from 'assets/revix-logo.jpeg'

export type IPageTheme = 'blue' | 'dark' | 'light';
export const Page = ({
    theme,
    title,
    children,
    hasLogo,
}: {
    theme: IPageTheme,
    children?: any | any[] | null;
    title?: string | any;
    hasLogo: boolean
}) => {
    const pageTheme: {
        [key in IPageTheme]: {
            PAGE_BACKGROUND: string;
            PAGE_TEXT: string;
        }
    } = {
        blue: {
            PAGE_BACKGROUND: '#212EEE',
            PAGE_TEXT: '#FFF',
        },
        dark: {
            PAGE_BACKGROUND: '#333',
            PAGE_TEXT: '#FFF',
        },
        light: {
            PAGE_BACKGROUND: '#FFF',
            PAGE_TEXT: '#333',
        },
    }
    return (<div style={{
        backgroundColor: pageTheme[theme].PAGE_BACKGROUND,
        color: pageTheme[theme].PAGE_TEXT,
        width: '100vw',
        height: '100vh',
        overflowY: 'auto',
    }}>
        {hasLogo && (
            <div>
                <img src={revixLogo} style={{ width: '3rem', marginTop: '1rem', marginBottom: '1rem' }} alt="revix-logo" />
            </div>
        )}
        {title && (
            <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                {title}
            </div>
        )}

        {children}
    </div>
    )
}

Page.defaultProps = {
    theme: 'light',
    hasLogo: false
}

export default Page;